export function elapsedStart(callback) {
    let start;
    const animate = (timestamp) => {
        if (start === undefined)
            start = timestamp;
        const elapsed = timestamp - start;

        if (elapsed < 1) {
            requestAnimationFrame((t) => animate(t));

        } else {
            callback?.();
        }
    }

    requestAnimationFrame(animate);
}

export function getCSSVal(element, property) {
  const styles = window.getComputedStyle(element);
  return styles.getPropertyValue(property);
}

export function debounce(callback, timing = 250) {
  let timer = null;
  return (...args) => {
    window.clearTimeout(timer);
    timer = setTimeout(() => { callback.apply(null, args); }, timing);
  }
}

export function str_trim(string) {
  if (!string || typeof string !== "string") return;

  return string
          .trim()
          .replace(/[\W_]/g, "")
          .toLowerCase();
}

export function array_has_intersection(arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) return;

  let found = false;
  
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      found = true;
      break;
    }
  }

  return found;
}